export default __webpack_public_path__ + "static/media/green-3.c8b7c8fd.svg";